import { HORECA } from '@/constants/testIds';
import LutfiyeLogo from './LutfiyeSignature';
import KidsStrip from './KidsStrip';
import { Instagram, Linkedin, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer
      data-testid={HORECA.footer}
      className="paper-cream text-[#1F1F1F]"
    >
      {/* Folk çocuk şeridi */}
      <div className="border-t border-b border-[#1F1F1F]/15 py-6 md:py-8 px-6">
        <div className="max-w-[1400px] mx-auto">
          <KidsStrip darkBg={false} />
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10 pt-16 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <LutfiyeLogo
              width="w-40 md:w-52"
              height="h-14 md:h-16"
              color="text-[#1F1F1F]"
            />
            <div className="eyebrow text-[#B08834] mt-3 mb-6">Horeca Kanalı</div>
            <p className="text-[#5A5145] leading-relaxed max-w-md font-body font-light">
              Karadeniz&apos;in bakir doğasından, katkısız ve sertifikalı organik
              ürünlerle; otel, restoran ve butik cafelerin sofralarına.
            </p>

            <div className="flex items-center gap-3 mt-8">
              {[
                { i: Instagram, l: 'Instagram' },
                { i: Linkedin, l: 'LinkedIn' },
                { i: Mail, l: 'E-posta' },
              ].map(({ i: Icon, l }) => (
                <a
                  key={l}
                  href="#"
                  aria-label={l}
                  className="w-10 h-10 border border-[#1F1F1F]/25 hover:bg-[#1F1F1F] hover:text-[#FBF7EE] hover:border-[#1F1F1F] transition-colors grid place-items-center"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.4} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-[#5A5145] mb-4">Keşfet</div>
            <ul className="space-y-3 text-sm font-body">
              {[
                ['#avantajlar', 'Avantajlar'],
                ['#urunler', 'Ürünler'],
                ['#hikayemiz', 'Amasra Kökü'],
                ['#surec', 'Süreç'],
                ['#sss', 'SSS'],
              ].map(([href, l]) => (
                <li key={href}>
                  <a href={href} className="text-[#1F1F1F]/75 hover:text-[#B03A2E] transition-colors">
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow text-[#5A5145] mb-4">İletişim</div>
            <ul className="space-y-3 text-sm text-[#1F1F1F]/75 font-body">
              <li>info@sanverhelva.com</li>
              <li>0378 266 11 33</li>
              <li>Bartın · Amasra · Ulus — Türkiye</li>
              <li>
                Perakende:{' '}
                <a
                  href="https://www.lutfiye.com"
                  target="_blank"
                  rel="noreferrer"
                  className="underline hover:text-[#B03A2E]"
                >
                  www.lutfiye.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#1F1F1F]/15 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-[#5A5145] font-body">
          <div>© {new Date().getFullYear()} Lutfiye Horeca. Tüm hakları saklıdır.</div>
          <div className="flex flex-wrap gap-2">
            <span className="label-pill text-[#5A5145]">Vegan</span>
            <span className="label-pill text-[#5A5145]">Glutensiz</span>
            <span className="label-pill text-[#5A5145]">Sertifikalı Organik</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
